import { memo } from 'react';
import useResponsive from '@/hooks/use-responsive';

interface IResponsiveProviderProps {
  children: React.ReactNode;
}

const ResponsiveProvider = memo(({ children }: IResponsiveProviderProps) => {
  useResponsive();
  return <>{children}</>;
});

ResponsiveProvider.displayName = 'ResponsiveProvider';

export default ResponsiveProvider;
